import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { DataTable, DataTablePagination } from 'components/common'
import { useQuery } from 'hooks'
import { fetchDeliverooSyncLogs } from 'utils/api/logsApi'
import { getColumns } from './utils'
import { filterEmptyValues, FilterMeta } from 'utils/helpers'
import { FILTER_FIELD_DELIVEROO_SYNC_LOG } from './deliverooSyncLogFilterForm'

type Props = {
  onFilterMeta?: (filterMeta: FilterMeta) => void
}

const DeliverooSyncLogTable = ({ onFilterMeta }: Props) => {
  const [logResponse, setLogResponse] = useState<any>({})

  const { search } = useLocation()
  const { getAllQueries } = useQuery()
  const columns = useMemo(() => getColumns(), [])

  // To get Deliveroo Sync Log data
  const getLogs = async () => {
    try {
      const queries = getAllQueries()
      const filters = filterEmptyValues(
        queries[FILTER_FIELD_DELIVEROO_SYNC_LOG] || {},
      )

      const { data } = await fetchDeliverooSyncLogs({
        limit: queries.limit || 10,
        page: queries.page || 1,
        filters,
      })
      setLogResponse(data)
      if (data?.filterMeta) {
        onFilterMeta?.(data.filterMeta)
      }
    } catch (error) {
      setLogResponse({ docs: [] })
    }
  }

  useEffect(() => {
    getLogs()
  }, [search])

  return (
    <>
      <DataTable columns={columns} rows={logResponse?.docs} identifier="_id" />

      {/* Table Pagination */}
      <DataTablePagination
        currentPage={logResponse?.page}
        totalPages={logResponse?.totalPages}
        hasNextPage={logResponse?.hasNextPage}
        hasPrevPage={logResponse?.hasPrevPage}
        limit={logResponse?.limit}
        nextPage={logResponse?.nextPage}
        prevPage={logResponse?.prevPage}
      />
    </>
  )
}

export default DeliverooSyncLogTable
